import React from "react";
import InstructionSection from "../InstructionSection";

function PathBuilderInstructionsOS({ t, options, osName }) {
  const show = options.osWindows || options.osMac || options.osLinux;
  if (!show) return null;

  return (
    <div className="instruction-category-group">
      <h3 className="instruction-category-header">{t("pathBuilder.categories.operatingSystem")}</h3>
      <InstructionSection
        title={t("pathBuilder.instructionTitles.instructionsForOS", { os: osName })}
        icon="💻"
      >
        <p>{t("pathBuilder.instructionContent.osSpecificInstructions")}</p>
      </InstructionSection>
    </div>
  );
}

export default PathBuilderInstructionsOS;
